import { io, type Socket } from 'socket.io-client';

let socket: Socket | null = null;

/** One authenticated socket per session (the httpOnly cookie is sent on the handshake). */
export function getSocket(): Socket {
  if (!socket) {
    socket = io(import.meta.env.VITE_API_URL || window.location.origin, {
      path: '/socket.io',
      withCredentials: true,
      // Default order (long-polling, then upgrade): still connects when a proxy such as
      // Netlify's does not forward WebSockets.
    });
  }
  return socket;
}

export function disconnectSocket() {
  socket?.disconnect();
  socket = null;
}
